import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import AppStore from "../../../stores/User/AppStore";
import { joinClassNames } from "../../../utils";
import styles from "./index.module.scss";
import IndexList from "../IndexList";
import AuthStore from "../../../stores/AuthStore";
export interface ScrollProps {}

const ScrollList: React.FC<ScrollProps> = (props) => {
  const { projects, typeCur, details } = AppStore;
  const params = useParams<{ projectId: string; appId: string }>();
  const navigate = useNavigate();
  const projectId = +(params.projectId ?? 0);
  const appId = +(params.appId ?? 0);
  const project = projects.find(
    (project) => project.id === +(params.projectId ?? 0)
  );
  const [contentValue, setContenValue] = useState<any>([]);

  useEffect(() => {
    AppStore.getDetails(
      project?.refUrlAppVoList.find((app) => app.id === appId)?.key ?? ""
    );
    const contentValue = projects
      .filter(
        (item) =>
          typeCur === 0 ||
          item.refUrlAppVoList.find((app) => app.type?.includes(typeCur))
      )
      .map((item) => {
        return {
          type: item.spellType,
          name: item.name,
          id: item.id,
          click: () =>
            navigate(`/user/list/${item.id}/${item.refUrlAppVoList[0].id}`),
        };
      });
    setContenValue(contentValue);
  }, [params.projectId, params.appId, project, typeCur]);

  return (
    <div className={styles.page_content_wrapper}>
      <div className={styles.scroll_left}>
        <IndexList contentValue={contentValue} />
        {/* {projects
          .filter(
            (item) =>
              typeCur === 0 ||
              item.refUrlAppVoList.find((app) => app.type?.includes(typeCur))
          )
          .map((item, idx) => (
            <div
              key={idx}
              className={joinClassNames([
                styles.list_item,
                item.id === project?.id && styles.active,
              ])}
              onClick={() =>
                navigate(`/user/list/${item.id}/${item.refUrlAppVoList[0].id}`)
              }
            >
              {item.name}
            </div>
          ))} */}
      </div>
      {project ? (
        <article className={styles.project_detail}>
          <h2>{project?.name}</h2>
          {project?.des ? (
            <div className={styles.project_des}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {project.des}
            </div>
          ) : (
            <div className={styles.project_des} style={{ textAlign: "center" }}>
              暂无描述
            </div>
          )}

          <p className={styles.app_tab}>
            {project?.refUrlAppVoList.map((app, idx) => (
              <span
                className={app.id === appId ? styles.active : undefined}
                key={idx}
                onClick={() => {
                  navigate(`/user/list/${project.id}/${app.id}`);
                }}
              >
                {app.name}
              </span>
            ))}
          </p>
          <div className={styles.navButton}>
            <button
              onClick={() => {
                AuthStore.linkToSubsystem(
                  project?.refUrlAppVoList.find((app) => app.id === appId)
                    ?.key ?? ""
                );
                // window.open(
                //   `/sso/pass?appkey=${
                //     project?.refUrlAppVoList.find((app) => app.id === appId)
                //       ?.key ?? ""
                //   }`,
                //   "blank"
                // );
              }}
            >
              点击进入{` >`}
            </button>
          </div>
          <section
            dangerouslySetInnerHTML={{ __html: details }}
            className={styles.details}
            // dangerouslySetInnerHTML={project?.refUrlAppVoList.find(
            //   (app) => app.id === appId
            // )}
          ></section>
        </article>
      ) : (
        <div className={styles.no_Data}>暂无数据</div>
      )}
    </div>
  );
};

export default observer(ScrollList);
